import { lazy } from "react";
import { Navigate, type RouteObject } from "react-router-dom";

const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const Catalog = lazy(() => import("../pages/catalog/page"));
const Delivery = lazy(() => import("../pages/delivery/page"));
const About = lazy(() => import("../pages/about/page"));
const Contacts = lazy(() => import("../pages/contacts/page"));
const Consultation = lazy(() => import("../pages/consultation/page"));
const Thank = lazy(() => import("../pages/thank/page"));
const Product = lazy(() => import("../pages/product/page"));
const Services = lazy(() => import("../pages/services/page"));
const ServiceDetail = lazy(() => import("../pages/services/detail/page"));
const Checkout = lazy(() => import("../pages/checkout/page"));
const CheckoutPayment = lazy(() => import("../pages/checkout/payment/page"));
const CartPage = lazy(() => import("../pages/cart/page"));
const Login = lazy(() => import("../pages/login/page"));
const Register = lazy(() => import("../pages/register/page"));
const Lk = lazy(() => import("../pages/lk/page"));
const LkOrders = lazy(() => import("../pages/lk-orders/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/catalog",
    element: <Catalog />,
  },
  {
    path: "/product/:id",
    element: <Product />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/:slug",
    element: <ServiceDetail />,
  },
  {
    path: "/consultation",
    element: <Consultation />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/checkout/delivery",
    element: <Navigate to="/checkout" replace />,
  },
  {
    path: "/checkout/payment",
    element: <CheckoutPayment />,
  },
  {
    path: "/delivery",
    element: <Delivery />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contacts",
    element: <Contacts />,
  },
  {
    path: "/thank",
    element: <Thank />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/lk",
    element: <Lk />,
  },
  {
    path: "/lk-orders",
    element: <LkOrders />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
